export default __webpack_public_path__ + "media/images/fluffy-elephant-friend-d6713fb6a10ff0f093d51c90383ed0bf.png";